import img_hisotry from "assets/img/history.svg";

import { MenuItemButton } from "components/menu/MenuItemButton";
import { ModalAssignmentHistory } from "../ModalAssignmentHistory";
import { useState } from "react";

export const MenuItemButtonAssignmentHistory = ({
  assignmentId,
}: {
  assignmentId: number;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <MenuItemButton
        onClick={() => {
          setOpen(true);
        }}
        title="История переписки"
        iconSrc={img_hisotry}
      />
      <ModalAssignmentHistory
        open={open}
        handleClose={() => setOpen(false)}
        assignmentId={assignmentId}
      />
    </>
  );
};
